export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) return '';
  
  // Оставляем только цифры
  const digits = phone.replace(/\D/g, '');
  
  // Проверяем длину и форматируем номер
  if (digits.length === 11) {
    return `+${digits[0]} ${digits.substring(1, 4)} ${digits.substring(4, 7)}-${digits.substring(7, 9)}-${digits.substring(9, 11)}`;
  }
  
  return phone; // Возвращаем исходный номер, если формат не подходит
}; 